"use client";

import { ComponentDisplayOnHoverContainer } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ComponentDisplayOnHoverContainer";
import { QuickAddProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { QuickAddBase } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/QuickAdd/QuickAddBase";
import { QuickAddModalContext } from "@faire/deprecated-retailer-visitor-shared/features/ProductQuickAddModal/QuickAddModalContext";
import { useProductTileClickImpressions } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import React from "react";

export const QuickAdd: React.FC<{
  data: QuickAddProps & { showOnHover: boolean };
  className?: string;
}> = ({ data, className }) => {
  const { recordProductTileClickEvent } = useProductTileClickImpressions(
    {
      token: data.productToken,
      brandToken: data.brandToken,
      impressionId: data.impressionId,
      promotedBy: data.promotedBy,
    },
    data.brandToken
  );

  // In the case where the user opens the quick add modal and navigates to the product details page,
  // we want to record a product tile click event
  const onViewProductDetailsClick = () => {
    recordProductTileClickEvent();
  };

  return (
    <QuickAddModalContext.Provider
      value={{ onViewProductDetailsClick: onViewProductDetailsClick }}
    >
      {data.showOnHover ? (
        <ComponentDisplayOnHoverContainer>
          <QuickAddBase data={data} className={className} />
        </ComponentDisplayOnHoverContainer>
      ) : (
        <QuickAddBase data={data} className={className} />
      )}
    </QuickAddModalContext.Provider>
  );
};
